import React, {Component} from 'react';
import HeaderComponent
    from "../../../Components/HeaderComponent/HeaderComponent";
import {
    Box, Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import SubHeaderComponent
    from "../../../Components/SubHeaderDefault/SubHeaderComponent";
import SpacerComponent
    from "../../../Components/SpacerComponent/SpacerComponent";
import {
    CardUserDetailsDividerStyled,
    CardUserDetailsDivStyled,
    CardUserDetailsLeftStyled,
    CardUserDetailsPaperStyled,
    CardUserDetailsStyled,
    ContentAddressStyled, ContentButtonModalStyled,
    ContentFidelityStyled,
    DivWithPaddingStyled,
    ImgFidelityStyled,
    MainContentStyled,
    TotalizadorContentStyled
} from "./styled";
import {Spa} from "@material-ui/icons";
import ReceiptIcon from '@material-ui/icons/Receipt';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import DateUtil from "../../../Utils/DateUtil";
import AwardService from "../../../Services/AwardService";
import MessageUtil from "../../../Utils/MessageUtil";
import InfoAwardScreen from "../NewAward/info/InfoAwardScreen";
import ModalComponent from "../../../Components/Modal/ModalComponent";
import TextFieldDefault
    from "../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import LoginValidation from "../../../FormValidations/LoginValidation";
import RoleUtil from "../../../Utils/RoleUtil";
import GeneralTranslation
    from "../../../Translations/FormValidations/GeneralTranslation";
import MeUtil from "../../../Utils/MeUtil";
import DashboardAdminScreen
    from "../../AdminAccess/DashboardAdminScreen/DashboardAdminScreen";
import ManagePaymentScreen from "../ManagePaymentScreen/ManagePaymentScreen";
import DashboardScreen from "../DashboardScreen/DashboardScreen";
import FidelityService from "../../../Services/FidelityService";
import ListNewAwardScreen from "../NewAward/ListNewAwardScreen";
import HistoryBlockComponent from "./Components/HistoryBlockComponent";

class ExtractClientScreen extends Component {
    static ROUTE = '/extract-client';

    awardService;
    fidelityService;

    constructor(props) {
        super(props);

        this.state = {
            inLoad: false,
            erros: [],
            data: null,
            total: 0,
            exits: 0,
            todayTotal: 0,
            isOpenModalBlock: false,
            isOpenModalHistory: false,
            clientUuid: null,
            fidelityUuid: null,
        };

        this.awardService = new AwardService();
        this.fidelityService = new FidelityService();
    }

    componentDidMount() {
        this.load();
    }

    load = async () => {
        try {

            if (!this.props.match.params?.client) {
                return;
            }

            if (!this.props.match.params?.fidelity) {
                return;
            }

            const clientUuid = this.props.match.params?.client;
            const fidelityUuid = this.props.match.params?.fidelity;

            this.setState({
                inLoad: true,
            })

            const response = await this.awardService.getClientData(
                clientUuid,
                fidelityUuid
            );

            this.setState({
                inLoad: false,
                data: response.data,
                clientUuid: clientUuid,
                fidelityUuid: fidelityUuid,
            });

        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Error',
                    body: e,
                }),
            });
        }
    }

    openModalBlock = () => {
        this.setState({
            isOpenModalBlock: true,
        })
    }

    closeModalBlock = () => {
        this.setState({
            isOpenModalBlock: false,
        })
    }

    openModalHistory = () => {
        this.setState({
            isOpenModalHistory: true,
        })
    }

    closeModalHistory = () => {
        this.setState({
            isOpenModalHistory: false,
        })
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState({[name]: value});
    }

    doBlockOrUnBlock = async () => {
        try {
            this.setState({
                inLoad: true,
            });


            if (this.state.data.blocked === false) {
                await this.fidelityService.doBlock({
                    object: {
                        client: this.state.clientUuid,
                        reason: this.state.reason,
                    },
                    uuid: this.state.fidelityUuid,
                });
            }

            if (this.state.data.blocked === true) {
                await this.fidelityService.doUnBlock({
                    object: {
                        client: this.state.clientUuid,
                        unblock_reason: this.state.reason,
                    },
                    uuid: this.state.fidelityUuid,
                });
            }

            this.setState({
                inLoad: false,
                isOpenModalBlock: false,
                messagens: MessageUtil.make({
                    title: 'Sucesso',
                    body: 'Ação concluida para o cliente',
                    okBtnToRoute: `${ExtractClientScreen.ROUTE}/${this.state.clientUuid}/${this.state.fidelityUuid}`,
                }),
            });

        } catch (e) {
            this.setState({
                inLoad: false,
                messagens: MessageUtil.make({
                    title: 'Atenção',
                    body: e,
                }),
            });
        }
    }

    render() {
        const clientIsBlock = this
            .state
            ?.data
            ?.blocked === true;

        return (
            <div>
                <HeaderComponent title={'Extrato do Cliente'}
                                 menu={true}
                                 messagens={this.state?.messagens}
                                 inLoad={this.state.inLoad}/>
                {this.state.data &&
                    <Box display={'flex'}
                         justifyContent={'center'}
                         alignItems={'center'}>
                        <Box width={'80%'}>
                            <SubHeaderComponent title={'Extrato do Cliente'}
                                                search={false}/>
                            <SpacerComponent height={50}/>

                            <MainContentStyled>
                                <div>
                                    <CardUserDetailsStyled>
                                        <Typography variant={'subtitle1'}
                                                    align={'center'}
                                                    color={'primary'}>{this.state.data.client.name}</Typography>
                                        <SpacerComponent height={30}/>
                                        <CardUserDetailsLeftStyled>
                                            <TotalizadorContentStyled>
                                                <ReceiptIcon color={'primary'}/>
                                                <span>Notas</span>
                                                <span><b>{this.state.data.client.totalInvoices}</b></span>
                                            </TotalizadorContentStyled>
                                            <TotalizadorContentStyled>
                                                <MonetizationOnIcon
                                                    color={'primary'}/>
                                                <span>Recibos</span>
                                                <span><b>{this.state.data.client.totalReceipts}</b></span>
                                            </TotalizadorContentStyled>
                                        </CardUserDetailsLeftStyled>
                                        <SpacerComponent height={20}/>
                                        <Typography variant={'subtitle1'}
                                                    color={'primary'}>Totalizadores</Typography>
                                        <span><b>Total de pontos: </b>{this.state?.data?.client?.totalPoints}</span>
                                        <span><b>Total utilizados: </b>{this.state?.data?.client?.totalUsedPoints}</span>
                                        <span><b>Saldo de hoje: </b>{this.state?.data?.client?.balance}</span>
                                        <SpacerComponent height={10}/>
                                        <Typography variant={'subtitle1'}
                                                    color={'primary'}>Detalhes</Typography>
                                        <span><b>Email:</b> {this.state.data.client.email}</span>
                                        <span><b>CPF:</b> {this.state.data.client.cpf}</span>
                                        <span><b>Data de nascimento:</b>{DateUtil.raw(this.state.data.client.birthday).toDate()}</span>
                                        <span><b>Telefone:</b> {this.state.data.client.phone}</span>
                                        <span><b>Endereço:</b></span>
                                        <ContentAddressStyled>
                                            <span><b>Estado:</b> {this.state.data.client.address.state}</span>
                                            <span><b>Cidade:</b> {this.state.data.client.address.city}</span>
                                            <span><b>Bairro:</b> {this.state.data.client.address.neighborhood}</span>
                                            <span><b>rua:</b> {this.state.data.client.address.address}</span>
                                            <span><b>Número:</b> {this.state.data.client.address.number}</span>
                                            <span><b>CEP:</b> {this.state.data.client.address.zip_code}</span>
                                        </ContentAddressStyled>
                                        <SpacerComponent height={10}/>
                                        <span><b>Útilmo login:</b> {DateUtil.raw(this.state.data.client.lastLogin).toDateTime()}</span>
                                    </CardUserDetailsStyled>
                                    <SpacerComponent height={30}/>
                                    <CardUserDetailsStyled>
                                        <Typography variant={'subtitle1'}
                                                    align={'center'}
                                                    color={'primary'}>Estado
                                            atual do Cliente:</Typography>
                                        <Typography variant={'subtitle1'}
                                                    align={'center'}
                                                    color={clientIsBlock ? 'error' : 'primary'}>{clientIsBlock ? 'BLOQUEADO' : 'ATIVO'}</Typography>
                                        <SpacerComponent height={30}/>
                                        <Button variant={'contained'}
                                                color={'primary'}
                                                size={"large"}
                                                onClick={this.openModalBlock}>
                                            {clientIsBlock ? 'DESBLOQUEAR' : 'BLOQUEAR'}
                                        </Button>
                                        <SpacerComponent height={30}/>
                                        <Button variant={'text'}
                                                color={'primary'}
                                                size={"large"}
                                                onClick={this.openModalHistory}>
                                            Histórico
                                        </Button>
                                    </CardUserDetailsStyled>
                                </div>
                                <SpacerComponent width={30}/>
                                <div>
                                    <CardUserDetailsPaperStyled>
                                        <ContentFidelityStyled>
                                            <ImgFidelityStyled>
                                                <img
                                                    src={this.state.data.fidelityProgram.image}/>
                                            </ImgFidelityStyled>
                                            <SpacerComponent width={20}/>
                                            <Typography variant={'subtitle1'}
                                                        color={'primary'}>{this.state.data.fidelityProgram.name}</Typography>
                                        </ContentFidelityStyled>
                                    </CardUserDetailsPaperStyled>
                                    <SpacerComponent height={20}/>
                                    <CardUserDetailsDivStyled>
                                        <TableContainer component={Paper}>
                                            <DivWithPaddingStyled>
                                                <Typography
                                                    variant={'subtitle1'}
                                                    color={'primary'}>Extrato</Typography>
                                            </DivWithPaddingStyled>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Pontos</TableCell>
                                                        <TableCell>Descrição</TableCell>
                                                        <TableCell>Data</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        this.state.data.balance?.map(function (value, i) {
                                                            return (
                                                                <TableRow
                                                                    key={i}>
                                                                    <TableCell>{value.points}</TableCell>
                                                                    <TableCell>{value.description}
                                                                        <br/>
                                                                        <a href={InfoAwardScreen.ROUTE + `/${value?.award_uuid}`}>{value?.details ?? ''}</a>
                                                                    </TableCell>
                                                                    <TableCell>{DateUtil.raw(value.created_at).toDateTime()}</TableCell>
                                                                </TableRow>
                                                            );
                                                        })
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </CardUserDetailsDivStyled>
                                </div>
                            </MainContentStyled>

                        </Box>
                    </Box>
                }

                <ModalComponent
                    isOpen={
                        this
                            .state
                            .isOpenModalBlock
                    }
                    onClose={
                        this
                            .closeModalBlock
                    }
                    title={
                        this
                            .state
                            ?.data
                            ?.blocked
                            ?
                            'Tem certeza que deseja DESBLOQUEAR esse Cliente' : 'Tem certeza que deseja BLOQUEAR esse Cliente'
                    }>
                    <Typography variant={'subtitle1'}>Por favor escreva o motivo
                        abaixo.</Typography>
                    <SpacerComponent height={20}/>
                    <TextFieldDefault label={'Motivo'}
                                      name={'reason'}
                                      type={'reason'}
                                      erros={this.props.erros}
                                      onChange={(event) => this.handleChange(event)}/>
                    <SpacerComponent height={30}/>
                    <ContentButtonModalStyled>
                        <Button variant={'text'}
                                color={'primary'}
                                size={"large"}
                                onClick={this.closeModalBlock}>
                            Cancelar
                        </Button>
                        <SpacerComponent width={30}/>
                        <Button variant={'contained'}
                                color={'primary'}
                                size={"large"}
                                disabled={this.state.reason ? false : true}
                                onClick={this.doBlockOrUnBlock}>
                            Concluir
                        </Button>
                    </ContentButtonModalStyled>
                </ModalComponent>
                <ModalComponent
                    maxWidth={1000}
                    isOpen={
                        this
                            .state
                            .isOpenModalHistory
                    }
                    onClose={
                        this
                            .closeModalHistory
                    }>
                    <HistoryBlockComponent
                        data={this.state?.data?.block_history}/>
                </ModalComponent>
            </div>
        )
            ;
    }
}

export default ExtractClientScreen;